import { OrganiserFilter, OrganiserFilterParams } from "./organiser-filter";

export class FindOrganisersRequest {
    constructor(private filter: OrganiserFilter) {
    }

    static createOrganisersRequest(params?: OrganiserFilterParams): FindOrganisersRequest {
        return new FindOrganisersRequest(OrganiserFilter.createOrganiserFilter(params));
    }
}
